export const supportedLanguages = {
    en: {
        label: "ENG",
        flag: "us"
    },
    us: {
        label: "ENG",
        flag: "us"
    },
    es: {
        label: "ESP",
        flag: "es"
    }
}

export const companyDetails = {
    email: "admin@visitallnepal.com",
    code: "+977",
    contact: "9819615916"
}